import { useState } from "react";
import DocumentMeta from "react-document-meta";
import FloatingWhatsAppButton from "../components/FloatingWhatsAppButton";

const Estate2026Page = () => {
    const pageUrl = "https://mauriziobrioschi.com/estate-2026";
    const shareImage = "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?q=80&w=1200&auto=format&fit=crop";
    const meta = {
        canonical: pageUrl,
        meta: {
            title: "Servizi web Sardegna 2026 | Sito per attività estive e turismo locale",
            name: {
                description: "Landing estate 2026 per piccole attività: siti web veloci, ottimizzati per Google e mobile, prenotazioni via WhatsApp e contenuti multilingua. Ideale per B&B, ristoranti, locali e tour operator in Sardegna.",
                keywords: "servizi web Sardegna, sito per attività estive, sito web B&B, sito web ristorante, tour operator Sardegna, marketing locale",
                robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
            },
            property: {
                "og:type": "website",
                "og:title": "Servizi web Sardegna 2026 | Sito per attività estive e turismo locale",
                "og:description": "Landing estate 2026 per piccole attività: siti web veloci, ottimizzati per Google e mobile, prenotazioni via WhatsApp e contenuti multilingua. Ideale per B&B, ristoranti, locali e tour operator in Sardegna.",
                "og:url": pageUrl,
                "og:image": shareImage,
                "og:image:width": "1200",
                "og:image:height": "630",
                "og:site_name": "Maurizio Brioschi",
                "og:locale": "it_IT",
                "og:locale:alternate": "en_US",
                "twitter:card": "summary_large_image",
                "twitter:title": "Servizi web Sardegna 2026 | Sito per attività estive e turismo locale",
                "twitter:description": "Landing estate 2026 per piccole attività: siti web veloci, ottimizzati per Google e mobile, prenotazioni via WhatsApp e contenuti multilingua. Ideale per B&B, ristoranti, locali e tour operator in Sardegna.",
                "twitter:image": shareImage,
                "twitter:url": pageUrl
            }
        }
    };
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Servizi web Sardegna - Landing Estate 2026",
        description:
            "Landing page per attività estive in Sardegna: siti veloci, ottimizzati per Google e mobile, con contatti e prenotazioni rapide.",
        areaServed: "Sardegna",
        serviceType: "Landing page e siti web per attività estive",
        provider: {
            "@type": "Person",
            name: "Maurizio Brioschi"
        },
        offers: {
            "@type": "Offer",
            priceCurrency: "EUR",
            price: "500",
            priceSpecification: {
                "@type": "PriceSpecification",
                priceCurrency: "EUR",
                price: "500",
                description: "A partire da 500 euro, in base ai servizi richiesti"
            }
        }
    };
    const faqJsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "Quanto costa una landing estate 2026?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Il prezzo parte da 500 euro e varia in base ai servizi richiesti."
                }
            },
            {
                "@type": "Question",
                name: "In quanto tempo viene pubblicata la landing?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "La pubblicazione avviene in tempi rapidi, in base ai materiali disponibili e alle integrazioni richieste."
                }
            },
            {
                "@type": "Question",
                name: "La landing è ottimizzata per smartphone?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Sì, il layout è progettato per essere chiaro e veloce su dispositivi mobili."
                }
            }
        ]
    };
    const [formState, setFormState] = useState({
        nome: "",
        email: "",
        telefono: "",
        richiesta: "",
        company: ""
    });
    const [formStatus, setFormStatus] = useState({ type: "idle", message: "" });
    const apiUrl = process.env.REACT_APP_ESTATE2026_API_URL;
    const buildFallbackMailto = () => {
        const subject = `Richiesta Estate 2026 - ${formState.nome || "Nuovo contatto"}`;
        const bodyLines = [
            `Nome: ${formState.nome || "-"}`,
            `Email: ${formState.email || "-"}`,
            `Telefono: ${formState.telefono || "-"}`,
            "",
            "Richiesta:",
            formState.richiesta || "-"
        ];
        const body = bodyLines.join("\n");
        return `mailto:info@mauriziobrioschi.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!apiUrl) {
            window.location.href = buildFallbackMailto();
            return;
        }
        setFormStatus({ type: "loading", message: "Invio in corso..." });
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formState)
            });
            if (!response.ok) {
                throw new Error("Errore invio");
            }
            setFormStatus({ type: "success", message: "Richiesta inviata. Ti rispondo al più presto." });
            setFormState({ nome: "", email: "", telefono: "", richiesta: "", company: "" });
        } catch (error) {
            window.location.href = buildFallbackMailto();
        }
    };

    return (
        <>
            <DocumentMeta {...meta} />
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
            <div className="min-h-screen bg-gradient-to-b from-amber-100 via-white to-sky-50 text-gray-900">
                <header className="relative overflow-hidden px-6 pt-10 pb-8 md:px-12 lg:px-20">
                    <div className="pointer-events-none absolute -top-16 left-1/2 h-56 w-56 -translate-x-1/2 rounded-full bg-amber-200/60 blur-3xl"></div>
                    <div className="pointer-events-none absolute -bottom-24 right-10 h-64 w-64 rounded-full bg-sky-200/60 blur-3xl"></div>
                    <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
                        <div className="max-w-2xl">
                            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-700">
                                Estate 2026
                            </p>
                            <h1 className="mt-4 text-4xl font-impact leading-tight md:text-5xl lg:text-6xl">
                                Porta nuove richieste già da questa estate
                            </h1>
                            <p className="mt-4 text-lg text-gray-700 md:text-xl">
                                Un sito chiaro e bello da usare, pensato per B&B, ristoranti, locali e tour operator.
                                Funziona benissimo su smartphone, dove la maggior parte delle persone cerca e prenota.
                            </p>
                            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                                <a
                                    href="#contatto"
                                    className="inline-flex items-center justify-center rounded-full bg-amber-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-amber-200 transition hover:bg-amber-700"
                                >
                                    Richiedi preventivo rapido
                                </a>
                                <a
                                    href="https://wa.me/393515699197"
                                    className="inline-flex items-center justify-center rounded-full border border-amber-600 px-6 py-3 text-sm font-semibold text-amber-700 transition hover:bg-amber-100"
                                >
                                    Scrivimi su WhatsApp
                                </a>
                            </div>
                            <div className="mt-6 flex flex-wrap gap-3 text-xs text-gray-600">
                                <span className="rounded-full bg-white/90 px-3 py-1 shadow">servizi web Sardegna</span>
                                <span className="rounded-full bg-white/90 px-3 py-1 shadow">sito per attività estive</span>
                                <span className="rounded-full bg-white/90 px-3 py-1 shadow">perfetto su smartphone</span>
                            </div>
                        </div>
                        <div className="relative max-w-md">
                            <div className="absolute -left-6 -top-6 h-24 w-24 rounded-full bg-amber-200 opacity-70 blur-xl"></div>
                            <div className="absolute -bottom-8 -right-8 h-28 w-28 rounded-full bg-sky-200 opacity-70 blur-xl"></div>
                            <div className="relative rounded-3xl bg-white p-6 shadow-2xl">
                                <div className="flex flex-col gap-4 text-sm text-gray-700">
                                    <div className="rounded-2xl bg-amber-50 p-4">
                                        <p className="text-xs font-semibold uppercase tracking-wide text-amber-700">
                                            Ottimizzato per mobile
                                        </p>
                                        <p className="mt-2 text-base font-semibold text-gray-900">
                                            La maggior parte delle prenotazioni arriva da smartphone.
                                        </p>
                                        <p className="mt-2 text-sm text-gray-600">
                                            Il sito è pensato per essere chiaro, veloce e facile da usare anche con una mano.
                                        </p>
                                    </div>
                                    <div className="rounded-2xl bg-sky-50 p-4">
                                        <p className="text-xs font-semibold uppercase tracking-wide text-sky-700">
                                            Contatto immediato
                                        </p>
                                        <p className="mt-2 text-sm text-gray-600">
                                            Un pulsante WhatsApp sempre visibile per richieste rapide.
                                        </p>
                                    </div>
                                    <div className="rounded-2xl bg-white p-4 shadow-sm">
                                        <p className="text-xs font-semibold uppercase tracking-wide text-emerald-700">
                                            Atmosfera estiva
                                        </p>
                                        <p className="mt-2 text-sm text-gray-600">
                                            Colori caldi, immagini luminose e testi semplici per far sentire le persone già in vacanza.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <main className="px-6 pb-32 md:px-12 lg:px-20">
                    <section className="mt-2 rounded-3xl bg-white/90 p-6 shadow-lg backdrop-blur md:p-10">
                        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                            <div>
                                <h2 className="text-2xl font-semibold md:text-3xl">Prezzo chiaro e senza sorprese</h2>
                                <p className="mt-2 text-gray-700">
                                    A partire da <span className="font-semibold">500 euro</span>, a seconda dei servizi richiesti.
                                </p>
                                <p className="mt-10 text-sm font-semibold text-gray-900">Servizi attivabili su richiesta</p>
                                <div className="mt-3 flex flex-wrap gap-2 text-sm text-gray-700">
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Prenotazione</span>
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Invio newsletter</span>
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Form contatti</span>
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Multilingua</span>
                                    <span className="rounded-full bg-amber-50 px-3 py-1">WhatsApp</span>optimi
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Integrazione social</span>
                                    <span className="rounded-full bg-amber-50 px-3 py-1">Funzionalità personalizzabili</span>
                                </div>
                            </div>
                            <div className="rounded-2xl bg-amber-50 px-6 py-4 text-sm text-gray-700">
                                Sempre inclusi: registrazione dominio, hosting, design mobile, testi semplici multilingua, statistiche sito, professionalità.
                            </div>
                        </div>
                    </section>

                    <section className="mt-4 rounded-3xl bg-white/90 p-6 shadow-lg backdrop-blur md:p-10">
                        <h2 className="text-2xl font-semibold md:text-3xl">Perché scegliere questa offerta stagionale</h2>
                        <ul className="mt-6 grid gap-4 text-base text-gray-700 md:grid-cols-2">
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="mt-1 h-2 w-2 rounded-full bg-amber-600"></span>
                                Ti trovano più facilmente su Google e da telefono.
                            </li>
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="mt-1 h-2 w-2 rounded-full bg-amber-600"></span>
                                Prenotazioni rapide via WhatsApp con un clic.
                            </li>
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="mt-1 h-2 w-2 rounded-full bg-amber-600"></span>
                                Testi multilingua per accogliere anche clienti stranieri.
                            </li>
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="mt-1 h-2 w-2 rounded-full bg-amber-600"></span>
                                Tempi rapidi, così sei online prima dell'alta stagione.
                            </li>
                        </ul>
                    </section>

                    <section className="mt-12 rounded-3xl bg-white p-6 shadow-lg md:p-10">
                        <h2 className="text-2xl font-semibold md:text-3xl">Come funziona</h2>
                        <ol className="mt-6 grid gap-4 text-gray-700 md:grid-cols-3">
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-600 text-white">
                                    1
                                </span>
                                <div>
                                    <p className="font-semibold">Brief</p>
                                    <p className="text-sm">Raccogliamo obiettivi, servizi e stile del tuo business.</p>
                                </div>
                            </li>
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-600 text-white">
                                    2
                                </span>
                                <div>
                                    <p className="font-semibold">Sviluppo</p>
                                    <p className="text-sm">Design, contenuti e integrazioni pronte per la stagione.</p>
                                </div>
                            </li>
                            <li className="flex items-start gap-3 rounded-2xl bg-amber-50 p-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-600 text-white">
                                    3
                                </span>
                                <div>
                                    <p className="font-semibold">Pubblicazione</p>
                                    <p className="text-sm">Messa online e ottimizzazione per ricerche locali.</p>
                                </div>
                            </li>
                        </ol>
                    </section>

                    <section className="mt-6">
                        <div className="rounded-3xl bg-gradient-to-br from-sky-100 via-white to-amber-100 p-6 shadow-lg md:p-10">
                            <h2 className="text-2xl font-semibold md:text-3xl">Esempi reali di landing estive</h2>
                            <p className="mt-2 text-gray-700">
                                Ogni landing qui sotto è un esempio completo e diverso dagli altri. Clicca per aprirla.
                            </p>
                            <div className="mt-6 grid gap-4 md:grid-cols-2">
                                <a href="/estate-2026/evento-estivo" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Evento estivo</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Festival al Tramonto 2026</p>
                                    <p className="mt-2 text-sm text-gray-600">Biglietti, programma e info pratiche.</p>
                                </a>
                                <a href="/estate-2026/locale-spiaggia" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Locale sulla spiaggia</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Lido Blu</p>
                                    <p className="mt-2 text-sm text-gray-600">Menù, serate e prenotazioni tavoli.</p>
                                </a>
                                <a href="/estate-2026/resort" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Resort</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Resort Cala Dorata</p>
                                    <p className="mt-2 text-sm text-gray-600">Camere, servizi e richieste dirette.</p>
                                </a>
                                <a href="/estate-2026/ristorante-mare" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Ristorante di mare</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Mare Azzurro</p>
                                    <p className="mt-2 text-sm text-gray-600">Menù estivo e prenotazioni semplici.</p>
                                </a>
                                <a href="/estate-2026/ristorante-collina" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Ristorante in collina</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">La Collina</p>
                                    <p className="mt-2 text-sm text-gray-600">Degustazioni e cucina locale.</p>
                                </a>
                                <a href="/estate-2026/casa-vacanza" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Casa vacanza</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Casa Vacanza Miraggio</p>
                                    <p className="mt-2 text-sm text-gray-600">Spazi, servizi e disponibilità.</p>
                                </a>
                                <a href="/estate-2026/campeggio" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Campeggio</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Campeggio Verde Mare</p>
                                    <p className="mt-2 text-sm text-gray-600">Tariffe e disponibilità.</p>
                                </a>
                                <a href="/estate-2026/promo-ferragosto" target="_blank" rel="noreferrer" className="rounded-2xl bg-white/90 p-4 shadow transition hover:shadow-lg">
                                    <p className="text-sm text-amber-700">Promo Ferragosto</p>
                                    <p className="mt-2 text-base font-semibold text-gray-900">Ferragosto in terrazza</p>
                                    <p className="mt-2 text-sm text-gray-600">Offerta speciale a tempo.</p>
                                </a>
                            </div>
                        </div>
                    </section>

                    <section className="mt-10 rounded-3xl bg-white/95 p-6 shadow-lg md:p-10">
                        <h2 className="text-2xl font-semibold md:text-3xl">Domande frequenti</h2>
                        <div className="mt-6 space-y-4">
                            <article className="rounded-2xl bg-amber-50 p-4">
                                <h3 className="text-lg font-semibold text-gray-900">Quanto costa una landing estate 2026?</h3>
                                <p className="mt-2 text-sm text-gray-700">Il prezzo parte da 500 euro e varia in base ai servizi richiesti.</p>
                            </article>
                            <article className="rounded-2xl bg-amber-50 p-4">
                                <h3 className="text-lg font-semibold text-gray-900">In quanto tempo viene pubblicata la landing?</h3>
                                <p className="mt-2 text-sm text-gray-700">
                                    La pubblicazione avviene in tempi rapidi, in base ai materiali disponibili e alle integrazioni richieste.
                                </p>
                            </article>
                            <article className="rounded-2xl bg-amber-50 p-4">
                                <h3 className="text-lg font-semibold text-gray-900">La landing è ottimizzata per smartphone?</h3>
                                <p className="mt-2 text-sm text-gray-700">Sì, il layout è progettato per essere chiaro e veloce su dispositivi mobili.</p>
                            </article>
                        </div>
                    </section>

                    <section id="contatto" className="mt-12 rounded-3xl bg-white p-6 shadow-lg md:p-10">
                        <div className="grid gap-8 lg:grid-cols-[1.1fr_1fr]">
                            <div>
                                <h2 className="text-2xl font-semibold md:text-3xl">Richiedi un contatto rapido</h2>
                                <p className="mt-3 text-gray-700">
                                    Compila il modulo e ricevi una proposta su misura per la tua attività estiva in
                                    Sardegna. Risposta in 24/48 ore.
                                </p>
                                <div className="mt-6 rounded-2xl bg-amber-50 p-4 text-sm text-gray-700">
                                    Ti aiutiamo a farti trovare più facilmente da chi cerca servizi web in Sardegna.
                                    Testi semplici e chiari, pensati per chi ti cerca da telefono.
                                </div>
                            </div>
                            <form className="space-y-4" onSubmit={handleSubmit}>
                                <div>
                                    <label htmlFor="nome" className="block text-sm font-semibold text-gray-700">
                                        Nome
                                    </label>
                                    <input
                                        id="nome"
                                        name="nome"
                                        type="text"
                                        required
                                        className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm shadow-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-200"
                                        placeholder="Nome e cognome"
                                        value={formState.nome}
                                        onChange={(event) => setFormState((prev) => ({ ...prev, nome: event.target.value }))}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        required
                                        className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm shadow-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-200"
                                        placeholder="nome@email.it"
                                        value={formState.email}
                                        onChange={(event) => setFormState((prev) => ({ ...prev, email: event.target.value }))}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700">
                                        Telefono
                                    </label>
                                    <input
                                        id="telefono"
                                        name="telefono"
                                        type="tel"
                                        className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm shadow-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-200"
                                        placeholder="+39 3XX XXX XXXX"
                                        value={formState.telefono}
                                        onChange={(event) => setFormState((prev) => ({ ...prev, telefono: event.target.value }))}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="richiesta" className="block text-sm font-semibold text-gray-700">
                                        Richiesta / Note
                                    </label>
                                    <textarea
                                        id="richiesta"
                                        name="richiesta"
                                        rows="4"
                                        required
                                        className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm shadow-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-200"
                                        placeholder="Raccontami la tua attività e cosa ti serve."
                                        value={formState.richiesta}
                                        onChange={(event) => setFormState((prev) => ({ ...prev, richiesta: event.target.value }))}
                                    />
                                </div>
                                <div className="hidden">
                                    <label htmlFor="company">Azienda</label>
                                    <input
                                        id="company"
                                        name="company"
                                        type="text"
                                        value={formState.company}
                                        onChange={(event) => setFormState((prev) => ({ ...prev, company: event.target.value }))}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={formStatus.type === "loading"}
                                    className="w-full rounded-xl bg-amber-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-amber-200 transition hover:bg-amber-700"
                                >
                                    Invia richiesta
                                </button>
                                {formStatus.message ? (
                                    <p
                                        className={`text-sm ${
                                            formStatus.type === "success"
                                                ? "text-emerald-700"
                                                : formStatus.type === "error"
                                                  ? "text-rose-700"
                                                  : "text-gray-600"
                                        }`}
                                    >
                                        {formStatus.message}
                                    </p>
                                ) : null}
                            </form>
                        </div>
                    </section>
                </main>
                <FloatingWhatsAppButton enabled phone="393515699197" offsetClass="bottom-24" />

                <footer className="fixed bottom-0 left-0 right-0 border-t border-amber-100 bg-white/95 px-6 py-4 text-xs text-gray-600 shadow-lg backdrop-blur md:px-12 lg:px-20">
                    <div className="flex flex-col items-start justify-between gap-2 md:flex-row md:items-center">
                        <div>
                            <p className="font-semibold text-gray-900">Maurizio Brioschi</p>
                            <p>info@mauriziobrioschi.com · +39 351 569 91 97</p>
                        </div>
                        <div className="text-gray-500">
                            <p>Note legali: privacy, cookie e termini su richiesta.</p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default Estate2026Page;
